export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-fast-forward-d07e6deadd14e75b13497f519b39f66b.svg";